import { AxiosResponse } from "axios";

import DiagnosticLogsApi from "./diagnostic-logs-api";
import { ScmaxDlogRecord } from "../types";

export type GetSCMaxDLogsRecordsParams = {
    mac_address: string;
    rids?: string[];
    start_date?: string;
    end_date?: string;
    page?: number;
    page_size?: number;
};


type PageRecordResponse = {
    items: ScmaxDlogRecord[];
    count: number;
    page: number;
    pageSize: number;
};


export const getSCMaxDLogsRecords = async (
    params: GetSCMaxDLogsRecordsParams
): Promise<PageRecordResponse> => {
    // format: link
    const { rids, ...otherParams } = params
    console.log(params)
    const typesString = (rids || [])?.map(rid => `rids=${rid}`).join('&') + ""
    const response: AxiosResponse<PageRecordResponse> = await DiagnosticLogsApi.get(
        `scmax/diag/records-by-mac-addr?${typesString}`,
        {
            params: otherParams,
        }
    );

    return response.data;
};


export default {
    getSCMaxDLogsRecords
}
